var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33863 6.70885C4.94433 7.31591 4.05567 7.31591 3.66137 6.70885L1.6062 3.54471C1.1741 2.87943 1.65154 2 2.44483 2L6.55517 2C7.34846 2 7.82591 2.87943 7.3938 3.5447L5.33863 6.70885Z",
    fill: "#465C6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDownIcon);
export default __webpack_public_path__ + "static/media/caret-down-icon.1e2da239be6d2c68fb00a1d0cfb171cb.svg";
export { ForwardRef as ReactComponent };